import React, { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { TreatmentsConsumerRenderProps, TreatmentsContext } from 'components/treatments/TreatmentsContext';
import { ConsultationsConsumerRenderProps, ConsultationsContext } from 'components/consultations/ConsultationsContext';
import ConsultationsInfo from 'components/consultations/ConsultationsInfo';
import { MessageSourceProps, withMessages } from "react-message-source";
import ConsultationsToolbar from 'components/consultations/ConsultationsToolbar';
import { PatientConsumerRenderProps, PatientContext } from 'components/patient/PatientContext';
import HomeLeftHeaderTitle from 'components/layout/HomeLeftHeaderTitle';
import HomeLeftHeader from 'components/layout/HomeLeftHeader';

const StyledConsultations = styled(Segment)`
  height: 386px;
`;

const Consultations = (props: MessageSourceProps) => {

  const {currentPatient}: PatientConsumerRenderProps = useContext(PatientContext);
  const {selectedTreatment, editTreatment}: TreatmentsConsumerRenderProps = useContext(TreatmentsContext);
  const {
    currentConsultations,
    selectedConsultation,
    changeConsultations,
    changeSelectedConsultation,
    addConsultation,
    editConsultation,
    deleteConsultation,
    onOpenUpsertModal,
    onCloseUpsertModal,
    consultationFormOpen,
    consultationId,
    setConsultationId,
    setCacheSearchId
  }: ConsultationsConsumerRenderProps = useContext(ConsultationsContext);

  return (
      <StyledConsultations>
        <HomeLeftHeader>
          <HomeLeftHeaderTitle>{props.getMessage('consultations')}</HomeLeftHeaderTitle>
          <ConsultationsToolbar
              currentPatient={currentPatient}
              currentTreatment={selectedTreatment}
              editTreatment={editTreatment}
              setConsultationId={setConsultationId}
              currentConsultation={selectedConsultation}
              addConsultation={addConsultation}
              editConsultation={editConsultation}
              deleteConsultation={deleteConsultation}
              onOpenUpsertModal={onOpenUpsertModal}
              onCloseUpsertModal={onOpenUpsertModal}
              setCacheSearchId={setCacheSearchId}
              consultationId={consultationId}
          />
        </HomeLeftHeader>
        <ConsultationsInfo
            currentPatient={currentPatient}
            editTreatment={editTreatment}
            currentConsultation={selectedConsultation}
            addConsultation={addConsultation}
            editConsultation={editConsultation}
            onOpenUpsertModal={onOpenUpsertModal}
            onCloseUpsertModal={onCloseUpsertModal}
            setConsultationId={setConsultationId}
            consultationFormOpen={consultationFormOpen}
            consultationId={consultationId}
            deleteConsultation={deleteConsultation}
            currentTreatment={selectedTreatment}
            selectedTreatment={selectedTreatment}
            currentConsultations={currentConsultations}
            selectedConsultation={selectedConsultation}
            changeConsultations={changeConsultations}
            changeSelectedConsultation={changeSelectedConsultation}
            setCacheSearchId={setCacheSearchId}
        />
      </StyledConsultations>
  )
};

export default withMessages(Consultations);
